import { forwardRef, memo, useCallback, useState } from "react";
import { TagInput, TagInputProps } from "../TagInput";

export type EmailInputProps = TagInputProps

export const EmailInput = memo(forwardRef<HTMLInputElement, EmailInputProps>(
  (
    {
      checkInputData,
      dividers = [ "Enter", " ", ",", ";" ],
      ...props
    }, ref) => {
    const [ errorText, setErrorText ] = useState("")

    const isEmail = useCallback((email: string | undefined) => {
      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email as string);
    }, []);

    const isInList = useCallback((email: string | undefined) => {
      return props.value?.includes(email as string);
    }, [ props.value ]);

    const wrapperCheckEmailData = useCallback((email: string | undefined) => {
      let error = null;

      if (isInList(email)) {
        error = `${email} has already been added.`;
      }

      if (!isEmail(email)) {
        error = `${email} is not a valid email address.`;
      }

      if (error) {
        setErrorText(error);
        return false;
      }

      setErrorText("")
      return true;
    }, [ isEmail, isInList ]);

    return (
      <TagInput
        {...props}
        ref={ref}
        dividers={dividers}
        errorText={errorText}
        checkInputData={wrapperCheckEmailData}
      />
    );
  },
));